"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOneWayLinkDstId = void 0;
const model_1 = require("../../model");
const command_manager_1 = require("../../command_manager");
const types_1 = require("../../types");
const lodash_1 = require("lodash");
const store_1 = require("../../exports/store");
exports.fixOneWayLinkDstId = {
    undoable: false,
    execute: (context, options) => {
        const { model: state } = context;
        const { datasheetId, fieldId, data } = options;
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if ((0, lodash_1.isEmpty)(data) || !snapshot) {
            return null;
        }
        const field = snapshot.meta.fieldMap[fieldId];
        const actions = data.reduce((collected, linkFieldOption) => {
            if (!linkFieldOption)
                return collected;
            const newField = Object.assign(Object.assign({}, field), { property: Object.assign(Object.assign({}, field.property), { brotherFieldId: linkFieldOption.newBrotherFieldId }) });
            const action = model_1.DatasheetActions.changeOneWayLinkDstId2Action(snapshot, { fieldId: fieldId, newField });
            action && collected.push(action);
            return collected;
        }, []);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions
        };
    },
};
//# sourceMappingURL=fix_one_way_link_dstId.js.map